import { isLinearUploadUrl } from "@productlane/lib"

import { api } from "@/lib/api"

// Linear rewrites every image in an issue description onto its own auth-gated
// CDN, so the browser gets a login redirect instead of bytes. Resolve a public
// mirror for display; the node's stored src keeps the Linear URL so the
// description we push back to Linear is byte-identical.
export function useMirroredLinearImage(src: string): {
	src: string
	isPending: boolean
} {
	const needsMirror = isLinearUploadUrl(src)
	const { data, isLoading } = api.linear.mirrorUpload.useQuery(
		{ url: src },
		{
			enabled: needsMirror,
			staleTime: Infinity,
			cacheTime: Infinity,
			retry: false,
		},
	)

	if (!needsMirror) return { src, isPending: false }
	if (data?.url) return { src: data.url, isPending: false }
	return { src, isPending: isLoading }
}
